module.exports = __webpack_public_path__ + "img/image-thumb-15.e9b57d50.jpg";